import type { TCommon } from '~/src/types/common'

export function extractFilenameFromHeaders(headers: TCommon) {
  const rawFilename = headers['content-disposition']
  return rawFilename.split('filename=')[1]
}

export function addParamsToURL(
  baseUrl: string,
  params: Record<string, string> = {},
): string {
  const url = new URL(baseUrl)

  Object.entries(params).forEach(([param, value]) => {
    url.searchParams.set(param, value)
  })

  return url.toString()
}
